import builder from '../builder';
import BathroomShower from '../../streamline-icons/bold/bathroom-shower.svg';

export default builder('IconBathroomShowerBold', BathroomShower);
